export default __webpack_public_path__ + "static/media/arrowRight.b22ef976.svg";